var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrcodeRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7272 5.76215C15.4397 5.5522 15.038 5.62381 14.8349 5.9249L14.3192 6.69147C13.7285 3.45594 10.9968 1 7.72132 1C4.01451 1 1 4.14113 1 8C1 11.8589 4.01451 15 7.72132 15C9.27468 15 10.7905 14.4352 11.9876 13.4083C12.2611 13.1739 12.3001 12.754 12.0751 12.4692C11.8501 12.1844 11.4469 12.1437 11.1734 12.3781C10.2045 13.2081 8.97776 13.6654 7.71976 13.6654C4.72087 13.6671 2.27988 11.1249 2.27988 8C2.27988 4.87515 4.72087 2.33295 7.72132 2.33295C10.4233 2.33295 12.6642 4.39502 13.0846 7.08696L12.161 6.41153C11.8735 6.20158 11.4719 6.27319 11.2687 6.57429C11.0671 6.87375 11.1359 7.29203 11.425 7.5036L13.5206 9.03674C13.8082 9.24669 14.2098 9.17508 14.4129 8.87398L15.885 6.69147C16.0866 6.39037 16.0163 5.97373 15.7272 5.76215Z",
    fill: "#616B84",
    stroke: "#F5F6FA",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodeRefresh);
export default __webpack_public_path__ + "static/media/qrcode-refresh.a7893b3a3890769377c540215a296d65.svg";
export { ForwardRef as ReactComponent };